module.exports = __webpack_public_path__ + "static/img/image4.76bf0c5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/2023/0112/image4.jpeg
// module id = zJ3W
// module chunks = 38